import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import AboutOne from '../Components/About/AboutOne'
import BrandOne from '../Components/Brand/BrandOne'
import GalleryOne from '../Components/Gallery/GalleryOne'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function About() {
    const { t } = useTranslation();
    
    return (
        <>
            <SEO 
                translationKey="seo.about"
                url="/about"
            />
            <HeaderOne />
            <Breadcrumb
                title={t("about.title")}
            />
            <AboutOne />
            <BrandOne />
            <GalleryOne />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default About
